import Icon from '../../components/Icon.vue'

Icon.register({"brands/uber":{"width":448,"height":512,"paths":[{"d":"M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446C0 464.8 15.2 480 33.9 480H414C432.7 480 447.9 464.8 447.9 446.1V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6H183.3V290C183.3 293.7 186.3 296.8 190.1 296.8H258C261.7 296.8 264.8 293.8 264.8 290V222.1C264.8 218.4 261.8 215.3 258 215.3H190.1C186.4 215.3 183.3 218.3 183.3 222.1V242.5H88.9C95.9 173.1 154.3 120.3 224 120.3 293.7 120.3 352.1 173.1 359.1 242.5 366.6 317 312.2 383.6 237.6 391.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/uber.js
// module id = null
// module chunks = 